export const MANUAL_ENTRY = 'MANUAL_ENTRY';
